import React from "react";

const SearchContext = React.createContext({
  items: [],
  compareToCabinet: true,
  addItem: (item) => {},
  removeItem: (id) => {},
  clearSearch: () => {},
  setCompareToCabinet: (setting) => {},
});

export default SearchContext;
